
namespace Gamification.Gamification {
    export class RisorseColumns {
        static columnsKey = 'Gamification.Risorse';
    }
}